// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2MemberNumberModel {
    static getAttributeTypeMap() {
        return EnrollmentV2MemberNumberModel.attributeTypeMap;
    }
}
EnrollmentV2MemberNumberModel.discriminator = undefined;
EnrollmentV2MemberNumberModel.attributeTypeMap = [
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "EnrollmentType"
    },
    {
        "name": "paymentMethod",
        "baseName": "paymentMethod",
        "type": "number"
    },
    {
        "name": "tcProgramId",
        "baseName": "tcProgramId",
        "type": "number"
    },
    {
        "name": "offerTypeId",
        "baseName": "offerTypeId",
        "type": "number"
    },
    {
        "name": "statusCode",
        "baseName": "statusCode",
        "type": "string"
    }
];
//# sourceMappingURL=enrollmentV2MemberNumberModel.js.map